import React from 'react';
import styles from './TalentPageLayout.module.scss';

export interface TalentPageLayoutProps {
  navbar: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
}

/**
 * Standard Talent sub-page chrome: sticky navbar + scrollable body below it.
 * Prevents list/detail content from scrolling into the iOS notch when the
 * document itself would otherwise rubber-band.
 */
const TalentPageLayout: React.FC<TalentPageLayoutProps> = ({
  navbar,
  children,
  className,
  contentClassName,
}) => (
  <div className={[styles.shell, className].filter(Boolean).join(' ')}>
    {navbar}
    <main className={[styles.content, contentClassName].filter(Boolean).join(' ')}>
      {children}
    </main>
  </div>
);

export default TalentPageLayout;
